export const getFirstFrame = videoUrl => {
	return new Promise((resolve, reject) => {
		const video = document.createElement('video')
		video.width = 640
		video.height = 360
		video.controls = true
		video.src = videoUrl
		video.className = 'visibleDom'
		video.crossOrigin = 'Anonymous'
		video.currentTime = 1
		document.body.appendChild(video)
		video.addEventListener('loadeddata', async () => {
			const canvas = document.createElement('canvas')
			document.body.appendChild(canvas)
			canvas.className = 'visibleDom'
			const ctx = canvas.getContext('2d')
			ctx.drawImage(video, 0, 0, 300, 150)
			const dataURL = canvas.toDataURL()
			console.log(dataURL, '0-0-0-')
			resolve(dataURL)
			setTimeout(() => {
				document.body.removeChild(canvas)
				document.body.removeChild(video)
			}, 100)
		})
		video.addEventListener('error', error => {
      console.error('获取封面失败', error)
			resolve('')
			setTimeout(() => {
				document.body.appendChild(video)
			}, 100)
		})
	})
}
